import { useEffect } from 'react';
import { classifyDeclaredClick, classifyLinkClick, trackEvent } from '../../services/analytics/track';

// Mide los clics en los CTA principales (enlaces a registrarse, ingresar y
// renovar), en los enlaces de WhatsApp y en los elementos con data-cta o
// data-aliado de todo el sitio con un solo listener, sin tocar cada botón.
// Así una landing nueva sale medida sin código adicional.
const AnalyticsClickTracker = () => {
  useEffect(() => {
    const onClick = (event) => {
      try {
        const element = event.target?.closest?.('[data-cta], [data-aliado], a[href]');
        if (!element) return;
        const context = {
          pathname: window.location.pathname,
          inMenu: Boolean(element.closest('nav, header')),
          inFooter: Boolean(element.closest('footer')),
        };
        const classified = classifyDeclaredClick(element.dataset, context)
          || (element.matches('a[href]') ? classifyLinkClick(element.getAttribute('href'), context) : null);
        if (classified) trackEvent(...classified);
      } catch (error) {
        // La medición nunca debe afectar la navegación.
      }
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
};

export default AnalyticsClickTracker;
